import { cn } from "@/lib/utils";
import { LoaderCircle, RotateCcw } from "lucide-react";
import { useState } from "react";

export const NoSearchResult = ({
  text,
  refetch,
  showRefreshButton = true,
}: {
  text: string;
  refetch: () => Promise<void>;
  showRefreshButton?: boolean;
}) => {
  const [isLoading, setIsLoading] = useState(false);
  return (
    <div className="w-full h-full flex flex-col items-center justify-center relative">
      <div className="flex flex-col items-center gap-[10px] self-stretch">
        {/* Frame 2087329587 */}
        <div className="w-[78px] h-[100px] relative">
          {/* Rectangle 5272 */}
          <div className="w-full h-full flex-shrink-0 rounded-[6.364px] bg-[#CBC7C8]" />
          {/* Frame 2087329586 */}
          <div className="inline-flex flex-col items-start gap-[9.091px] blur-[1.818px] absolute top-[24.5px] left-[10px]">
            <div className="w-[35.455px] h-[4.545px] rounded-[0.909px] bg-[#444]" />
            {/* Frame 2087329584 */}
            <div className="flex flex-col items-start gap-[4.545px] self-stretch">
              <div className="w-[61.818px] h-[4.545px] rounded-[0.909px] bg-[#444]" />
              <div className="w-[61.818px] h-[4.545px] rounded-[0.909px] bg-[#444]" />
              <div className="w-[61.818px] h-[4.545px] rounded-[0.909px] bg-[#444]" />
            </div>
          </div>
          {/* Frame 2087329585 */}
          <div className="inline-flex flex-col items-start gap-[9.091px] absolute top-[22.73px] left-[8.18px]">
            <div className="w-[35.455px] h-[4.545px] rounded-[0.909px] bg-[#808080]" />
            {/* Frame 2087329584 */}
            <div className="flex flex-col items-start gap-[4.545px] self-stretch">
              <div className="w-[61.818px] h-[4.545px] rounded-[0.909px] bg-[#808080]" />
              <div className="w-[61.818px] h-[4.545px] rounded-[0.909px] bg-[#808080]" />
              <div className="w-[61.818px] h-[4.545px] rounded-[0.909px] bg-[#808080]" />
            </div>
          </div>
        </div>
        {/* Frame 2087329560 */}
        <div className="flex w-[252px] flex-col items-center gap-[8px]">
          <span className="overflow-hidden text-neutral-600 text-center overflow-ellipsis body-1-normal-medium">
            {text}
          </span>
          {showRefreshButton && (
            <button
              className="flex h-8 p-2 justify-center items-center gap-2 rounded-md border-[1px] border-[#E5E5E5] shadow-xs hover:bg-neutral-100 hover:shadow-sm active:bg-neutral-200 active:shadow-none"
              onClick={() => {
                if (isLoading) return;
                setIsLoading(true);
                refetch().finally(() => {
                  setIsLoading(false);
                });
              }}
            >
              <RotateCcw className="w-4 h-4 aspect-square" />
              <span className="caption-1-medium text-[#0A0A0A]">새로고침</span>
            </button>
          )}
        </div>
      </div>
      <div
        className={cn(
          "absolute top-0 left-0 w-full h-full transition-all flex items-center justify-center",
          isLoading
            ? "duration-300 bg-white/50 backdrop-blur-[4px]"
            : "duration-0 pointer-events-none",
        )}
      >
        {isLoading && (
          <LoaderCircle
            className={cn(
              "w-[40px] h-[40px] animate-spin text-[#0A0A0A] transition-opacity mb-16",
              isLoading ? "opacity-100" : "opacity-0",
            )}
          />
        )}
      </div>
    </div>
  );
};
